import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApplicationUrlService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfigProvider) {}

  public getUrls() {
    return this.appConfig.environment.pipe(
      mergeMap(env => {
        return this.http.get<IModuleUrl[]>(`${env.API.CUSTOMERCONFIG}/api/Module/Urls`);
      })
    );
  }
}

export interface IModuleUrl {
  id: number;
  name: string;
  moduleUrl: string;
}
